import React from "react";
import { BoxIcon } from "lucide-react";
interface SummaryCardProps {
  title: string;
  icon?: BoxIcon;
  action?: React.ReactNode;
  children: React.ReactNode;
}
export function SummaryCard({
  title,
  icon: Icon,
  action,
  children
}: SummaryCardProps) {
  return <section className="rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-309" data-mp="12krl6mx8hv8q">
      <header className="flex items-center justify-between gap-4 border-b border-slate-100 px-5 py-3.5" data-id="element-310" data-mp="xqwyrbq8v25y">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-900" data-id="element-311" data-mp="1cj7ackcpaufl">
          {Icon && <Icon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-312" data-mp="17k45p10muq85" />}
          {title}
        </h3>
        {action}
      </header>
      <div className="px-5 py-4" data-id="element-313" data-mp="1hggzs003b63f">{children}</div>
    </section>;
}
interface DetailGroupProps {
  label: string;
  children: React.ReactNode;
}
export function DetailGroup({
  label,
  children
}: DetailGroupProps) {
  return <div data-id="element-314" data-mp="3j8c1pnwjnw8g">
      <p className="mb-3 text-[11px] font-semibold uppercase tracking-wide text-slate-400" data-id="element-315" data-mp="3j8vnxgt896sa">
        {label}
      </p>
      <dl className="space-y-2.5" data-id="element-316" data-mp="azlm081fkamv">{children}</dl>
    </div>;
}
interface DetailRowProps {
  label: string;
  value: string;
  muted?: boolean;
}
export function DetailRow({
  label,
  value,
  muted = false
}: DetailRowProps) {
  return <div className="flex items-baseline justify-between gap-4" data-id="element-317" data-mp="pmohyaa3ub83">
      <dt className="text-sm text-slate-500" data-id="element-318" data-mp="po9gsc3gcgbr">{label}</dt>
      <dd className={`text-right text-sm font-medium ${muted ? 'italic text-slate-400' : 'text-slate-900'}`} data-id="element-319" data-mp="umawqo5kzzj0">
        {value}
      </dd>
    </div>;
}